/**
 * SearchVirtualKeyboardContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled search virtual keyboard container.
 */
const SearchVirtualKeyboardContainer = styled.div<React.CSSProperties>`
  width: ${250 * Screen.widthRatio}px;
`;

export default SearchVirtualKeyboardContainer;
